import {forwardRef} from "react";
import {t} from "i18next";
import {FormLabel} from "./FormLabel";
import {Checkbox} from "./Checkbox";
import classes from "./form-elements.module.css";

interface OptionalFormProps {
    checked: boolean;
    hasFocus: boolean;
    id: string;
    keyword: string;
    text: string;
    heading?: string;
    onChange?: () => void;
    onFocus?: () => void;
    onBlur?: () => void;
}

export const OptionalForm = forwardRef<HTMLLabelElement, OptionalFormProps>(
    ({checked, id, keyword, text, heading, onChange, onFocus, onBlur}, ref) => {
        const displayText = keyword || text;
        const sectionHeading =
            heading ||
            t("DocumentGenerator.OptionalContent", "Valgfritt innhold");

        return (
            <FormLabel
                value={sectionHeading}
                ref={ref}
                className={classes.optionalLabel}
            >
                <Checkbox
                    checked={checked}
                    onChange={onChange}
                    id={id}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    className={classes.optionalCheckbox}
                />
                <p className={classes.optionalText}>{displayText}</p>
            </FormLabel>
        );
    }
);

OptionalForm.displayName = "OptionalForm";
